(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow-with-product-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
 var swiper = new Swiper('.slider-featured-products-section .swiper-container', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  speed: 1000,
  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },
  pagination: {
    el: '.swiper-counter',
    type: 'custom',
    renderCustom: function (swiper, current, total) {
      return `${current}/${total}`;
    }
  },
  spaceBetween: 0,
  on: {
    init: function () {
      /* updateCounter is not defined */
      // updateCounter();
    },
    slideChangeTransitionStart: function () {
      document.querySelectorAll('.slider-featured-products-section .slide-content').forEach(function (content) {
        content.style.opacity = '0';
        content.style.transform = 'translateY(20px)';
        content.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';
      });
    },
    slideChangeTransitionEnd: function () {
      let activeSlide = document.querySelector('.slider-featured-products-section .swiper-slide-active .slide-content');
      if (activeSlide) {
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateY(0)';
        activeSlide.style.transition = 'opacity 0.5s ease-in, transform 0.5s ease-in';
      }
    }
  }
});
});

  } catch(e) { console.error(e); }
})();
})();
